import { WeatherComponent } from './components/WeatherComponent';
import { SVG } from 'components/Asset/SVG';
import HeaderActions from './components/HeaderActions';
import {
  getAppLogo,
  clientThemePalette,
  CLIENT_THEME,
} from 'utils/clientTheme';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';
import './TopBar.css';

export const TopBar = () => {
  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = isDarkTheme(theme);
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const colorMode = enableDarkTheme ? 'dark' : 'light';
  const { topbarBg, topbarGradient, primary } =
    clientThemePalette[CLIENT_THEME][colorMode];

  return (
    <div
      className="poppins-regular top-header"
      style={{
        background: topbarGradient ?? topbarBg,
        borderBottom: topbarGradient ? `1px solid ${primary}55` : undefined,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          gap: '10px',
        }}
      >
        {(() => {
          const logo = getAppLogo();
          return logo.type === 'img' ? (
            <img
              src={logo.src}
              alt={logo.alt}
              style={{ width: '180px', height: '100%', objectFit: 'contain' }}
            />
          ) : (
            <SVG
              name={logo.svgName}
              style={{ width: '180px', height: '100%' }}
            />
          );
        })()}
      </div>

      <WeatherComponent />
      <HeaderActions />
    </div>
  );
};
